import { render, staticRenderFns } from "./BaseToggleSwitch.vue?vue&type=template&id=4d4bb4ea&scoped=true&"
import script from "./BaseToggleSwitch.vue?vue&type=script&lang=ts&"
export * from "./BaseToggleSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./BaseToggleSwitch.vue?vue&type=style&index=0&id=4d4bb4ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4bb4ea",
  null
  
)

export default component.exports